export default __webpack_public_path__ + "static/media/play_button.0b62a797.webp";